import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchDeliveryProcess(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/show_process/${delivery_process_id}`
    );
  },

  fetchProducers(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/manage_delivery_process_providers/${delivery_process_id}/fetch_producers`
    );
  },

  fetchDeliveryProcessProvider(service_provider_id, delivery_process_id, id) {
    return RequesterV1.get(
      `service_provider/delivery/managing/${service_provider_id}/manage_delivery_process_providers/${delivery_process_id}/fetch_delivery_process_provider/${id}`
    );
  },

  create(service_provider_id, delivery_process_id, delivery_process_provider) {
    return RequesterV1.post(
      `service_provider/delivery/managing/${service_provider_id}/manage_delivery_process_providers/${delivery_process_id}/create`,
      { delivery_process_provider }
    );
  },

  update(
    service_provider_id,
    delivery_process_id,
    id,
    delivery_process_provider
  ) {
    return RequesterV1.post(
      `service_provider/delivery/managing/${service_provider_id}/manage_delivery_process_providers/${delivery_process_id}/update/${id}`,
      { delivery_process_provider }
    );
  },

  destroy(service_provider_id, delivery_process_id, id) {
    return RequesterV1.delete(
      `service_provider/delivery/managing/${service_provider_id}/manage_delivery_process_providers/${delivery_process_id}/destroy/${id}`
    );
  },
};
